export var PANEL_HEADER_HEIGHT = 40;
export var PANEL_FOOTER_HEIGHT = 40;
export var TREE_ROOT_ID = 'XFLOW_TREE_PANEL_ROOT_ID';
export var CONTAINER_CLASS = 'flowchart-node-panel-collpase';
